// @flow
import * as React from 'react';
import withAnalytics from 'shared/hoc/withAnalytics';
import ErrorMessageBlock from './ErrorMessageBlock';

type Props = {
  widgetId: string,
  isSSRMode?: boolean,
  children: React.Element<any> | React.Element<any>[]
}

type State = {
  hasError: boolean
}

// Hides the component on error
class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    const { widgetId } = this.props;

    console.error(error);
    console.log(info);

    this.props.analytics.trackUIEventError('Genesis Error', `${error.message} [${widgetId}] [${info.componentStack}]`);
  }

  render() {
    const { children, isEditor, widgetId, isSSRMode } = this.props;
    const { hasError, errorMessage } = this.state;

    if (hasError) {
      if (isEditor) {
        return <ErrorMessageBlock errorMessage={errorMessage} />;
      }
      if (isSSRMode) {
        const safeMsg = (errorMessage || '').replace(/-->/g, '--&gt;');
        return <div dangerouslySetInnerHTML={{
          __html: `<!-- SSR_WIDGET_ERROR: ${widgetId} | ${safeMsg} -->`
        }} />;
      }
      return null;
    }

    return children;
  }
}

export default withAnalytics(ErrorBoundary);
